import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import MovieCard from "@/components/feature/MovieCard";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryQuick from "@/pages/home/components/CategoryQuick";
import HotList from "@/pages/home/components/HotList";
import { movies } from "@/mocks/movies";
import { useSeo } from "@/hooks/useSeo";

const latest = [...movies]
  .sort((a, b) => b.year - a.year || b.views - a.views)
  .slice(0, 10);

const recommended = [...movies]
  .sort((a, b) => b.rating - a.rating || b.views - a.views)
  .slice(0, 8);

const topics = [
  {
    title: "双向奔赴的都市情缘",
    desc: "从针锋相对到并肩同行，看成熟男女如何把喜欢藏进日常。",
    tag: "都市情感",
    to: "/category/电视剧",
  },
  {
    title: "青春里的暗恋与重逢",
    desc: "校服、梧桐与旧信，写给每一段没说出口的喜欢。",
    tag: "青春校园",
    to: "/category/电视剧",
  },
  {
    title: "跨越时空的宿命之恋",
    desc: "古装情缘与海外佳作，那些注定相遇的爱情故事。",
    tag: "古装情缘",
    to: "/category/电影",
  },
];

export default function Home() {
  useSeo({
    title: "恋爱的味道-情感影视作品大全与剧情介绍",
    description:
      "恋爱的味道网站提供丰富的情感类影视作品资源，涵盖最新电视剧、电影以及经典剧情介绍，带您感受浪漫爱情故事的精彩与温馨。",
    keywords: "恋爱的味道,爱情电视剧,情感影视,恋爱剧情,影视作品,电影推荐,剧情简介",
  });

  return (
    <SiteLayout>
      <HeroCarousel />

      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-8">
        <div className="flex flex-col gap-6 py-10 lg:flex-row lg:gap-8">
          <div className="min-w-0 flex-1">
            <div className="flex items-end justify-between gap-4">
              <div>
                <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
                  <span className="flex h-7 w-7 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                    <i className="ri-movie-2-line text-base"></i>
                  </span>
                  最新影视
                </h2>
                <p className="mt-1 text-sm text-foreground-600">新鲜上线的爱情作品，第一时间追起来</p>
              </div>
              <Link
                to="/category/电视剧"
                className="shrink-0 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap"
              >
                更多 <i className="ri-arrow-right-s-line"></i>
              </Link>
            </div>

            <div className="mt-5 grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4">
              {latest.map((movie) => (
                <MovieCard key={movie.id} movie={movie} />
              ))}
            </div>

            <div className="mt-12">
              <div className="flex items-end justify-between gap-4">
                <div>
                  <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
                    <span className="flex h-7 w-7 items-center justify-center rounded-md bg-accent-100 text-accent-600">
                      <i className="ri-award-line text-base"></i>
                    </span>
                    热门推荐
                  </h2>
                  <p className="mt-1 text-sm text-foreground-600">高评分与人气口碑兼具的情感佳作</p>
                </div>
                <Link
                  to="/category/电影"
                  className="shrink-0 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap"
                >
                  更多 <i className="ri-arrow-right-s-line"></i>
                </Link>
              </div>

              <div className="mt-5 grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4">
                {recommended.map((movie, i) => (
                  <MovieCard key={movie.id} movie={movie} rank={i + 1} />
                ))}
              </div>
            </div>
          </div>

          <aside className="w-full shrink-0 space-y-6 lg:w-[340px]">
            <CategoryQuick />
            <HotList />
          </aside>
        </div>

        <section className="pb-4">
          <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
            <span className="flex h-7 w-7 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
              <i className="ri-bookmark-3-line text-base"></i>
            </span>
            编辑精选专题
          </h2>
          <div className="mt-5 grid grid-cols-1 gap-4 md:grid-cols-3">
            {topics.map((topic) => (
              <Link
                key={topic.title}
                to={topic.to}
                className="group rounded-lg border border-background-200 bg-white p-5 transition-colors hover:border-primary-300"
              >
                <span className="inline-block rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
                  {topic.tag}
                </span>
                <h3 className="mt-3 font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
                  {topic.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{topic.desc}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-600">
                  查看专题 <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
            ))}
          </div>
        </section>
      </div>

      <section className="mt-12 bg-background-100">
        <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-8">
          <div className="flex flex-col gap-8 lg:flex-row lg:items-center">
            <div className="flex-1">
              <h2 className="font-heading text-2xl font-bold text-foreground-950">关于恋爱的味道</h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-700">
                「恋爱的味道」是一个专注情感类影视作品的内容站。我们收录爱情电视剧、经典电影与
                <strong className="font-semibold text-foreground-900"> 海外口碑佳作 </strong>
                ，为每一部作品整理详细的剧情简介、演职员信息与看点解析，帮助你在海量影视里快速找到
                真正想看的那一部，感受温馨浪漫的观影体验。
              </p>
              <div className="mt-6 flex flex-wrap gap-3">
                <Link
                  to="/about"
                  className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
                >
                  了解更多
                </Link>
                <Link
                  to="/search"
                  className="inline-flex items-center gap-2 rounded-md border border-background-300 px-5 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:bg-background-200 whitespace-nowrap"
                >
                  <i className="ri-search-line"></i>
                  去搜索
                </Link>
              </div>
            </div>
            <div className="grid flex-1 grid-cols-3 gap-4">
              {[
                { value: "28+", label: "精选作品" },
                { value: "5", label: "情感分类" },
                { value: "每日", label: "持续更新" },
              ].map((stat) => (
                <div
                  key={stat.label}
                  className="rounded-lg border border-background-200 bg-white p-4 text-center"
                >
                  <p className="font-heading text-2xl font-bold text-primary-600">{stat.value}</p>
                  <p className="mt-1 text-xs text-foreground-600">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}